import {useMutation} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpSendTestMail} from '@/features/mailer/http/mailer.http'
import {TestSendResponse} from '@/features/mailer/types'

interface UseSendTestMailOptions {
    onSuccess?: (data: TestSendResponse) => void
    onError?: (error: unknown) => void
}

// Synchronous test send to the logged operator's email (no batch is created).
export const useSendTestMail = ({onSuccess, onError}: UseSendTestMailOptions = {}) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.SEND_TEST_MAIL],
        mutationFn: httpSendTestMail,
        onSuccess,
        onError
    })
